import { render } from "./MatchPage.vue?vue&type=template&id=90e23e14"
import script from "./MatchPage.vue?vue&type=script&lang=js"
export * from "./MatchPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__